<!-- eslint-disable vue/no-v-model-argument -->
<template>
  <OrderList
    v-model="localValue"
    :dataKey="dataKey"
    :listStyle="listStyle"
    :dragdrop="dragdrop"
    :selection="selection"
    :metaKeySelection="metaKeySelection"
    :responsive="responsive"
    :breakpoint="breakpoint"
    :stripedRows="stripedRows"
    :disabled="disabled"
    @selection-change="onSelectionChange"
    @reorder="onReorder"
  >
    <template #item="slotProps">
      <slot name="item" v-bind="slotProps">
        {{ slotProps.item }}
      </slot>
    </template>
  </OrderList>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import OrderList from 'primevue/orderlist'
import type { OrderListItem, OrderListProps, OrderListEmits } from './types'

const props = withDefaults(defineProps<OrderListProps>(), {
  modelValue: () => [],
  dataKey: undefined,
  listStyle: () => ({}),
  dragdrop: false,
  selection: () => [],
  metaKeySelection: true,
  responsive: true,
  breakpoint: '960px',
  stripedRows: false,
  disabled: false
})

const emit = defineEmits<OrderListEmits>()

const localValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const onSelectionChange = (event: { originalEvent: Event; value: OrderListItem[] }) => {
  emit('selection-change', event)
}

const onReorder = (event: { originalEvent: Event; value: OrderListItem[]; direction: string }) => {
  emit('reorder', event)
}
</script>
